import { HTTP } from "@/utils/http";
import Apis from "@/apis";
import {safeObj} from "@/utils/safeObj";

const CREATE_NEW_TEMPLATE = 'CREATE_NEW_TEMPLATE';
const GET_CURRENT_DAY_TEMPLATE = 'GET_CURRENT_DAY_TEMPLATE';
const GET_AD_BREAKS = 'GET_AD_BREAKS';
const GET_LANGUAGES = 'GET_LANGUAGES';
const SET_DAY_TEMPLATE = 'SET_DAY_TEMPLATE';
const SET_DRAGGED_DAY_TEMPLATE_UID = 'SET_DRAGGED_DAY_TEMPLATE_UID';


const initialState = () => ({
    allTemplates: null,
    templateCreated: null,
    isCreatingTemplateLoading: false,
    currentDayTemplate: null,
    isGetCurrentDayTemplate: false,
    adBreaks: null,
    isGetAdBreaks: false,
    languages: [],
    isGetLanguages: false,
    templatesByUid: {},
    draggedDayTemplateUid: null
});

export const Templates = {
    namespaced: true,
    state: initialState,
    mutations: {
        [CREATE_NEW_TEMPLATE] (state, {data, loading}) {
            if(data) {
                state.templateCreated = data;
            }
            state.isCreatingTemplateLoading = loading;
        },
        [GET_CURRENT_DAY_TEMPLATE] (state, {data, loading}) {
            if(data) {
                state.currentDayTemplate = data;
            }
            state.isGetCurrentDayTemplate = loading;
        },
        [GET_AD_BREAKS] (state, {data, loading}) {
            if(data) {
                state.adBreaks = data;
            }
            state.isGetAdBreaks = loading;
        },
        [GET_LANGUAGES] (state, {data, loading}) {
            if(data) {
                state.languages = data;
            }
            state.isGetLanguages = loading;
        },
        [SET_DAY_TEMPLATE] (state, { data, uid }) {
          state.templatesByUid[uid] = data
        },
        [SET_DRAGGED_DAY_TEMPLATE_UID] (state, uid) {
          state.draggedDayTemplateUid = uid
        }
    },
    actions: {
        createTemplate({commit}, {stationUid, name, colorCode}) {
            return new Promise((resolve, reject) => {
                commit(CREATE_NEW_TEMPLATE, {loading: true});

                HTTP.post(Apis.daytemplates.create, {
                    params: {
                        stationUid,
                        name,
                        colorCode
                    }})
                    .then(response => {
                        commit(CREATE_NEW_TEMPLATE, {data: response.data.dataItem, loading: false});
                        const { dataItem, errors, isSuccess } = response.data;
                        resolve({ dataItem, errors, isSuccess });
                    })
                    .catch(error => {
                        commit(CREATE_NEW_TEMPLATE, {data: [], loading: false});
                        reject(error)
                    })
            })
        },
        getCurrentDayTemplate({commit}, {scheduleDate, stationUid}) {
            return new Promise((resolve, reject) => {
                commit(GET_CURRENT_DAY_TEMPLATE, {loading: true});

                HTTP.get(Apis.planning.details, {
                    params: {
                        scheduleDate,
                        stationUid
                    }})
                    .then(response => {
                        commit(GET_CURRENT_DAY_TEMPLATE, {data: response.data.dataItem, loading: false});
                        const { dataItem, errors, isSuccess } = response.data;
                        resolve({ dataItem, errors, isSuccess });
                    })
                    .catch(error => {
                        commit(GET_CURRENT_DAY_TEMPLATE, {data: [], loading: false});
                        reject(error)
                    })
            })
        },
        getCurrentAdBreaks({commit}, {stationUid, dayTemplateUid}) {
            return new Promise((resolve, reject) => {
                commit(GET_AD_BREAKS, {loading: true});

                HTTP.get(Apis.daytemplates.adBreaks, {
                    params: {
                        stationUid,
                        dayTemplateUid
                    }})
                    .then(response => {
                        commit(GET_AD_BREAKS, {data: response.data.dataItem, loading: false});
                        const { dataItem, errors, isSuccess } = response.data;
                        resolve({ dataItem, errors, isSuccess });
                    })
                    .catch(error => {
                        commit(GET_AD_BREAKS, {data: [], loading: false});
                        reject(error)
                    })
            })
        },
        getLanguages({commit}) {
            return new Promise((resolve, reject) => {
                commit(GET_LANGUAGES, {loading: true});

                HTTP.get(Apis.parameters.languages)
                    .then(response => {
                        commit(GET_LANGUAGES, {data: response.data.dataItem, loading: false});
                        const { dataItem, errors, isSuccess } = response.data;
                        resolve({ dataItem, errors, isSuccess });
                    })
                    .catch(error => {
                        commit(GET_LANGUAGES, {data: [], loading: false});
                        reject(error)
                    })
            })
        },
        async fetchDayTemplateDetails({ commit, state }, { stationUid, dayTemplateUid }) {
          if (Object.keys(state.templatesByUid).includes(dayTemplateUid)) {
            return
          }

          try {
            const response = await HTTP.get(Apis.daytemplates.details, {
              params: {
                  stationUid,
                  dayTemplateUid
              }
            })

            commit('SET_DAY_TEMPLATE', { uid: dayTemplateUid, data: response.data.dataItem })
          } catch (e) {
            console.log('error', e)
          }
        },
        setDraggedDayTemplateUid ({ commit }, uid) {
          commit(SET_DRAGGED_DAY_TEMPLATE_UID, uid)
        }
    },
    getters: {
        getCountDayTemplate: state => {
            return safeObj(state.currentDayTemplate)
        }
    }
};
